
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Target, Flag, Book, BarChart } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const QuickLinks = () => {
  const { t } = useTranslation('common');
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">{t('help.quickLinks.title')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <Link to="/training" className="flex items-center gap-2 p-2 rounded-md hover:bg-golf-50 transition-colors">
          <Book className="h-4 w-4 text-golf-600" />
          <span>{t('help.quickLinks.trainingExercises')}</span>
        </Link>
        
        <div className="border border-gray-200 rounded-lg p-3">
          <h3 className="font-semibold text-sm text-gray-700 mb-2">{t('help.quickLinks.pelzTests')}</h3>
          <div className="space-y-2">
            <Link to="/putting" className="flex items-center gap-2 p-2 rounded-md hover:bg-golf-50 transition-colors">
              <Target className="h-4 w-4 text-golf-600" />
              <span>{t('help.quickLinks.startPuttingTest')}</span>
            </Link>
            <Link to="/approaches" className="flex items-center gap-2 p-2 rounded-md hover:bg-golf-50 transition-colors">
              <Flag className="h-4 w-4 text-golf-600" />
              <span>{t('help.quickLinks.approachTest')}</span>
            </Link>
            <Link to="/results" className="flex items-center gap-2 p-2 rounded-md hover:bg-golf-50 transition-colors">
              <BarChart className="h-4 w-4 text-golf-600" />
              <span>{t('help.quickLinks.viewResults')}</span>
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickLinks;
